import Head from "next/head"
import Link from "next/link"
import { BlitzPage, Routes } from "@blitzjs/next"
import { useRouter } from "next/router"
import { useQuery, useMutation } from "@blitzjs/rpc"
import Layout from "app/core/layouts/Layout"
import Suspense from "app/core/components/Suspense"
import getBrands from "app/brands/queries/getBrands"

import Container from "@mui/material/Container"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box"
import Tooltip from "@mui/material/Tooltip"
import IconButton from "@mui/material/IconButton"
import EditIcon from "@mui/icons-material/Edit"
import RefreshIcon from "@mui/icons-material/Refresh"
import configureBrandRedirects from "app/brands/mutations/configureBrandRedirects"

export const BrandsList = () => {
  const router = useRouter()
  const page = Number(router.query.page) || 0
  const [brands] = useQuery(getBrands, {
    orderBy: { name: "asc" },
  })

  const [configureBrandRedirectsMutation, { isLoading: configureBrandRedirectsMutationIsLoading }] =
    useMutation(configureBrandRedirects)

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Domains</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {brands.map((brand) => (
            <TableRow key={brand.id} hover={true}>
              <TableCell>{brand.name}</TableCell>
              <TableCell>
                {brand.domains
                  .map((d) => d.name)
                  .sort()
                  .join(", ")}
              </TableCell>
              <TableCell sx={{ py: 0 }}>
                <Stack direction="row" justifyContent="flex-end">
                  {!configureBrandRedirectsMutationIsLoading && (
                    <Tooltip title="Force redirect configuration">
                      <IconButton
                        onClick={async (e) => {
                          e.stopPropagation()
                          await configureBrandRedirectsMutation({ id: brand.id })
                        }}
                      >
                        <RefreshIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Link href={Routes.EditBrandPage({ brandId: brand.id })} legacyBehavior>
                    <IconButton>
                      <EditIcon />
                    </IconButton>
                  </Link>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const BrandsPage: BlitzPage = () => {
  return (
    <>
      <Head>
        <title>Brands</title>
      </Head>

      <Container maxWidth={false}>
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <Typography sx={{ my: 4, flexGrow: 1 }} variant="h4" component="h2">
            Brands
          </Typography>
        </Box>
        <Suspense>
          <BrandsList />
        </Suspense>
      </Container>
    </>
  )
}

BrandsPage.authenticate = true
BrandsPage.getLayout = (page) => <Layout>{page}</Layout>

export default BrandsPage
